import { type LucideIcon } from 'lucide-react';

export function Icon({ icon: Glyph, size = 18, className = '' }: { icon: LucideIcon; size?: number; className?: string }) {
  return <Glyph size={size} strokeWidth={1.8} className={className} aria-hidden="true" />;
}
